











































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { getVideoListByPage, getVrListByPage } from "@/axios";

@Component({
  name: "vrVideo",
})
export default class extends Vue {
  @Prop()
  inputVrVideoData: any;

  // 右侧推荐(video)
  private recommend: any = [];
  // 中间内容数据(video)
  private mainList: any = [];
  // 右侧推荐(vr)
  private recommendVR: any = [];
  // 中间内容数据(vr)
  private mainListVR: any = [];

  private landmarkId: any = "";

  @Watch("inputVrVideoData", { immediate: true, deep: true })
  oninputVrVideoData(val: any, oldVal: any) {
    if (val) {
      this.recommend = val.recommendVideo;
      this.mainList = val.videoArray;
      this.recommendVR = val.recommendVrManage;
      this.mainListVR = val.vrManageArray;
      this.listCount = val.vrManageCount;

      if ((this as any).$route.query.landmarkId) {
        this.landmarkId = (this as any).$route.query.landmarkId;
      }

      this.getData();
    }
  }

  private switchItemIndex(index: any) {
    this.tabItemIndex = index;
    this.page = 1;
    this.getData();
    // console.log('this.tabItemIndex---',this.tabItemIndex,index)
  }

  // @Watch("tabItemIndex", {immediate: true, deep: true})
  // ontabItemIndex(val: any, oldVal: any) {
  //   if( val == 0 ){
  //     this.recommend = this.vrVideoData.recommendVideo;
  //     this.mainList = this.vrVideoData.videoArray;
  //   } else {
  //     this.recommend = this.vrVideoData.recommendVrManage;
  //     this.mainList = this.vrVideoData.vrManageArray;
  //   }
  // }

  private vrVideoData: any = {
    cityList: [],
    recommendVideo: [],
    recommendVrManage: [],
    videoArray: [],
    vrManageArray: [],
  };

  private cityItemIndex: any = 0;
  private tabItemIndex: any = 0;
  private dialogShow: any = false;
  private videoUrl: any = "";

  private vrdialogShow: any = false;
  private vrUrl: any = "";

  // private tabCityItemIndex (index:any) {
  //   this.cityItemIndex = index;
  // }

  private showVideo(url: any) {
    this.videoUrl = url;
    this.dialogShow = true;
    // console.log(url)
  }

  private showVr(url: any) {
    this.vrUrl = url;
    this.vrdialogShow = true;
    // console.log(url)
  }

  private page: any = 1;
  private page_size: any = 9;
  private listCount: any = 0;

  private pageChange(page: any) {
    this.page = page;
    this.getData();
  }
  mounted() {
    this.getData();
  }
  private getData() {
    if (this.tabItemIndex == 0) {
      // 宣传视频
      getVideoListByPage({
        page_size: this.page_size,
        page: this.page,
        landmark_id: this.landmarkId,
      }).then((res: any) => {
        this.listCount = res.data.data.count;
        this.mainList = res.data.data.data;

        // console.log('getVideoListByPage---------',res)
      });
    }
    if (this.tabItemIndex == 1) {
      getVrListByPage({
        page_size: this.page_size,
        page: this.page,
        landmark_id: this.landmarkId,
      }).then((res: any) => {
        this.listCount = res.data.data.count;
        this.mainListVR = res.data.data.data;

        // console.log('getVideoListByPage---------',res)
      });
    }
  }
}
